import { SET_AUTOBILL_DATA } from "../ActionName/ActionName";

const initialState = {
    autoBillData: null,
    timestamp: Date.now()
}

const AutoBillReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_AUTOBILL_DATA:
            return ({ ...state, autoBillData: action.value, timestamp: Date.now() })
        default:
            return state;
    }
}

export default AutoBillReducer;
